module.exports = angular.module('msi.layout.forbidden', []).name;

angular.module(module.exports)
  .config(require('./states'));
